export default {
  // Page title and subtitle
  'page.mainTitle': 'Discordタイムスタンプジェネレーター',
  'page.mainTitleSEO': 'Discordタイムスタンプジェネレーター - 動的な<t:format>コードを作成',
  'page.subtitle': '全員に自動タイムゾーン変換されるDiscordタイムスタンプを生成',

  // Generator tool section
  'page.generatorTitle': 'インタラクティブDiscordタイムスタンプジェネレーター',
  'page.selectDateTime': '日時を選択：',
  'page.chooseFormat': '表示フォーマットを選択：',
  'page.generatedCode': '生成されたDiscordコード：',
  'page.preview': 'Discordでのプレビュー：',
  'page.copyCode': 'コードをコピー',

  // Format options
  'page.format.t': '短い時刻',
  'page.format.t.example': '午後4:30',
  'page.format.t.desc': '時刻のみ表示、短いフォーマット',

  'page.format.T': '長い時刻',
  'page.format.T.example': '午後4:30:00',
  'page.format.T.desc': '時刻のみ表示、秒付き',

  'page.format.d': '短い日付',
  'page.format.d.example': '2024/12/31',
  'page.format.d.desc': '日付のみ表示、短いフォーマット',

  'page.format.D': '長い日付',
  'page.format.D.example': '2024年12月31日',
  'page.format.D.desc': '完全な日付を表示',

  'page.format.f': '短い日付/時刻',
  'page.format.f.example': '2024年12月31日 午後4:30',
  'page.format.f.desc': '最も一般的に使用されるフォーマット',

  'page.format.F': '長い日付/時刻',
  'page.format.F.example': '2024年12月31日火曜日 午後4:30',
  'page.format.F.desc': '曜日付きの完全な日付と時刻',

  'page.format.R': '相対時間',
  'page.format.R.example': '2時間前 / 3日後',
  'page.format.R.desc': '動的なカウントダウンまたは経過時間',

  // Format reference table
  'page.formatReference': 'Discordタイムスタンプフォーマットリファレンス',
  'page.formatCode': 'フォーマットコード',
  'page.style': 'スタイル',
  'page.exampleOutput': '出力例',
  'page.useCase': '使用例',

  'page.useCase.t': 'イベント開始時刻',
  'page.useCase.T': '正確なタイミング',
  'page.useCase.d': 'コンパクトな日付表示',
  'page.useCase.D': '完全な日付表示',
  'page.useCase.f': '一般的な用途',
  'page.useCase.F': '正式な発表',
  'page.useCase.R': 'カウントダウン、イベントからの時間',

  // How to use section
  'page.howToUse': 'Discordタイムスタンプの使い方',
  'page.step1': 'タイムスタンプコードを生成',
  'page.step1Desc': '上記のツールを使用して日時とフォーマットを選択',

  'page.step2': '生成されたコードをコピー',
  'page.step2Desc': '例：<t:1735689000:F>',

  'page.step3': '任意のDiscordメッセージに貼り付け',
  'page.step3Desc': 'テキストチャンネル、DM、スレッド、フォーラム投稿で動作',

  'page.step4': '全員が自分のタイムゾーンで表示！',
  'page.step4Desc': 'Discordが各ユーザーの現地時間に自動変換',

  // FAQ section
  'page.faq': 'Discordタイムスタンプ FAQ',

  'page.faq.q1': 'Discordタイムスタンプとは？',
  'page.faq.a1': 'DiscordタイムスタンプはUnixエポックタイムを特別なフォーマットコード（<t:timestamp:format>）で使用し、各ユーザーの現地タイムゾーンに自動調整される動的な時刻を表示します。',

  'page.faq.q2': '時刻を入力する代わりにDiscordタイムスタンプを使用する理由は？',
  'page.faq.a2': 'Discordタイムスタンプは各ユーザーの現地タイムゾーンに自動変換されるため、全員がその場所の正しい時刻を見ることができます。これにより、タイムゾーン間でイベントを調整する際の混乱が解消されます。',

  'page.faq.q3': 'どのフォーマットを使用すべきですか？',
  'page.faq.a3': 'カウントダウンとイベントには<t:timestamp:R>を、正式な発表には<t:timestamp:F>を、一般的な目的には<t:timestamp:f>を使用します。',

  'page.faq.q4': 'Discordタイムスタンプはすべてのチャンネルで動作しますか？',
  'page.faq.a4': 'はい！Discordタイムスタンプは、テキストチャンネル、DM、スレッド、フォーラム投稿、チャンネルトピックでも動作します。',

  'page.faq.q5': 'Discordタイムスタンプを埋め込みで使用できますか？',
  'page.faq.a5': 'はい、Discordボットを使用する場合、Discordタイムスタンプは埋め込みの説明とフィールド値で動作します。',

  'page.faq.q6': '無効なタイムスタンプを使用するとどうなりますか？',
  'page.faq.a6': 'Discordは変換せずに生のコードを表示します。有効なUnixタイムスタンプを使用してください。',

  // Related tools section
  'page.relatedTools': '関連タイムスタンプツール',
  'page.needUnixTimestamp': 'Unixタイムスタンプが必要ですか？',
  'page.needUnixTimestampDesc': '私たちのUnixタイムスタンプコンバーターを使用して、任意の日付をエポックタイムに変換します。',
  'page.checkYouTubeTool': 'またはYouTubeタイムスタンプクリエーターをチェック',

  // Common use cases
  'page.commonUseCases': '一般的な使用例',
  'page.useCase1.title': 'イベントスケジューリング',
  'page.useCase1.desc': 'ゲームナイト、映画鑑賞パーティー、コミュニティイベントを発表',

  'page.useCase2.title': 'レイドタイマー',
  'page.useCase2.desc': '異なるタイムゾーン間でゲームセッションを調整',

  'page.useCase3.title': 'リリースカウントダウン',
  'page.useCase3.desc': 'ゲームローンチ、アルバムドロップ、アップデートの興奮を作る',

  'page.useCase4.title': '会議リマインダー',
  'page.useCase4.desc': 'コミュニティサーバーでチーム会議をスケジュール',

  'page.useCase5.title': 'コンテスト締め切り',
  'page.useCase5.desc': 'プレゼントとコンペティションの明確な締め切りを設定',

  'page.useCase6.title': 'サーバーイベント',
  'page.useCase6.desc': '記念日、マイルストーン、特別な機会を追跡',
};